import type { ApiErrorDto } from '../model/dto';
import { mapAnalyticsExport } from '../model/mappers';
import type { AnalyticsExport } from '../model/types';

const getErrorBody = (error: unknown): ApiErrorDto | null => {
    if (!error || typeof error !== 'object') {
        return null;
    }

    const data = (error as { data?: unknown }).data;

    if (!data || typeof data !== 'object') {
        return null;
    }

    const body = data as Partial<ApiErrorDto>;

    return typeof body.message === 'string' ? (body as ApiErrorDto) : null;
};

export const getApiErrorMessage = (error: unknown, fallback: string): string =>
    getErrorBody(error)?.message ?? fallback;

export const getConflictExport = (error: unknown): AnalyticsExport | null => {
    const conflict = getErrorBody(error)?.conflict_message;

    return conflict ? mapAnalyticsExport(conflict) : null;
};